import { ref, reactive } from '@nuxtjs/composition-api';
import { useUiState } from '~/composables/useUiState';

const isOpenModal = ref(false);
const modalProduct = ref(null);
const modalSelectedOptions = reactive({
  color: null,
  size: null,
});

export const useAddToCartModal = () => {
  const { isAddCartModalOpen, toggleAddCartModal } = useUiState();

  const openAddToCartModal = (product, selectedOptions = { color: null, size: null }) => {
    modalProduct.value = product;
    modalSelectedOptions.color = selectedOptions.color;
    modalSelectedOptions.size = selectedOptions.size;
    toggleAddCartModal();
    isOpenModal.value = isAddCartModalOpen.value;
  };

  const closeAddToCartModal = () => {
    if (isAddCartModalOpen.value) {
      toggleAddCartModal();
      isOpenModal.value = isAddCartModalOpen.value;
    }
  };

  return {
    isOpenModal: isAddCartModalOpen,
    modalProduct,
    modalSelectedOptions,
    openAddToCartModal,
    closeAddToCartModal,
  };
};
